import { Button } from 'components'
import Flex from 'components/priority/Flex/Flex'
import { CaseInputSelector } from '.'
import caseForm from 'utils/forms/caseForm'
import { useTranslation } from 'react-i18next'

export const CaseFormSection = ({
  saveAndContinue,
  formSection,
  sidebar = false,
  isM3Order = false,
}) => {
  const { t } = useTranslation()
  const isHonors = formSection === 'honors'
  // A field marked m3Only shows only when the caller says the order is M3
  // (useIsM3Order); every other caller leaves it out.
  const formFields = caseForm[formSection].filter(
    (formField) => !formField.m3Only || isM3Order,
  )
  return (
    <>
      <Flex wrap="wrap" width="100%">
        {formFields.map((formField, index) => (
          <CaseInputSelector
            key={`${formField}_${index}`}
            formField={formField}
          />
        ))}
      </Flex>
      {!sidebar && (
        <Flex justify="flex-end">
          <Button
            primary
            onClick={() => {
              saveAndContinue(formSection)
            }}
          >
            {!isHonors
              ? t('caseDetails.saveAndContinueButton')
              : t('caseDetails.saveButton')}
          </Button>
        </Flex>
      )}{' '}
    </>
  )
}

export default CaseFormSection
